import { render, staticRenderFns } from "./CampaignsPage.vue?vue&type=template&id=e76be9e2&"
import script from "./CampaignsPage.vue?vue&type=script&lang=js&"
export * from "./CampaignsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports